import BigNumber from 'bignumber.js'

// @ts-ignore
export function fmtTokenAmount(amount: any, dp = 2): string {
  const fmt = {
    prefix: '',
    decimalSeparator: '.',
    groupSeparator: ',',
    groupSize: 3,
    secondaryGroupSize: 0,
    fractionGroupSeparator: ' ',
    fractionGroupSize: 0,
    suffix: '',
  }
  return new BigNumber(amount).toFormat(dp, BigNumber.ROUND_DOWN, fmt)
}

export function fmtPrecision(amount: any, dp = 4): string {
  return new BigNumber(amount).decimalPlaces(dp, BigNumber.ROUND_DOWN).toString()
}

export function fmtSignificantDigits(amount: any): string {
  return new BigNumber(amount).toString()
}

export function fmtToFixed(amount: any, dp = 4): string {
  return new BigNumber(amount).toFixed(dp, BigNumber.ROUND_DOWN)
}

export function checkInputAmount(amount: any): boolean {
  const amountBN = new BigNumber(amount)
  if (amountBN.isNaN() || !amountBN.isFinite() || amountBN.comparedTo('0') <= 0) {
    return false
  }
  return true
}

export function isNumber(amount: any): boolean {
  const amountBN = new BigNumber(amount)
  if (amountBN.isNaN() || !amountBN.isFinite()) {
    return false
  }
  return true
}
